/* eslint-disable */
//* settings.js 会把变量挂到 window上，所以需要放到最顶层，不然其他文件从window读取变量时读不到
import './settings';
import { ReduxContext } from "@tencent/react-aio"
import reducer from "./stores/sale/reducers"
import App from "./app"
import WebApi from "./api/sale"
import { computeGetUrl, isOa, getBearerToken } from "@/utils"
import { REACT_APP_PUBLIC_URL } from "@/constants/Constants"
import "@/assets/tailwind.css"
import "@/assets/fonts/font.css"
import "@tencent/od-icon/lib/styles/css/od-icon.css";
import "./init"
import { configure as mobxConfigure } from "mobx"
import Echarts from "echarts"
import * as serviceWorker from './serviceWorker';

window.echarts = Echarts // spa-ui使用
window.pageProps.basename = REACT_APP_PUBLIC_URL

mobxConfigure({ enforceActions: "always" })

const token = getBearerToken()
const context = ReduxContext.forDOM()
  .configureStore(reducer)
  .render(App, {
    webApiClass: WebApi,
    headers:
      window.pageProps &&
      (() => {
        if (isOa() && token) {
          return { ...window.pageProps.headers, Authorization: `Bearer ${token}` }
        }
        return { ...window.pageProps.headers }
      }),
    additionalSearch: computeGetUrl(window.pageProps && window.pageProps.additionalSearch),
  })

if (module.hot) {
  module.hot.accept("./stores/sale/reducers", () => {
    context.replaceReducer(require("./stores/sale/reducers").default)
  })
  module.hot.accept(["./app", "./api/sale"], () => {
    context.render(App, { webApiClass: WebApi })
  })
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.register();
